import React, { FC, useCallback, useState } from 'react';
import { Alert, Button, message } from 'antd';
import { useConnection } from '../../../connection/Application';

/**
 * Shown when silent renewal was refused (the Microsoft re-check failed). The current session
 * keeps working until it expires; signing in again here starts a new one without leaving the page.
 */
export const SessionExpiryBanner: FC = () => {
  const connection = useConnection();
  const [loading, setLoading] = useState<boolean>(false);

  const onSignIn = useCallback(() => {
    setLoading(true);
    connection
      .reauthenticate()
      .catch(() => message.error('Sign-in did not complete. Please try again.'))
      .finally(() => setLoading(false));
  }, [connection]);

  if (!connection.isReauthRequired()) {
    return null;
  }
  const expiresAt = connection.getSessionExpiry();
  const endsAt = expiresAt
    ? new Date(expiresAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : undefined;
  return (
    <Alert
      banner
      type="warning"
      showIcon
      message={
        endsAt
          ? `Your session ends at ${endsAt}. Sign in again to keep working.`
          : 'Your session is ending. Sign in again to keep working.'
      }
      action={
        <Button size="small" type="primary" loading={loading} onClick={onSignIn}>
          Sign in again
        </Button>
      }
    />
  );
};
